<template>
	<v-select
		solo
		hide-details
		class="header-select"
		v-bind="$attrs"
		:items="items"
		:value="value"
		@input="sendValue"
	></v-select>
</template>
<script>

	function sendValue(val) {
		this.$emit('input', val);
	}

	export default {
		name: 'header-select',
		inheritAttrs: false,
		methods: {
			sendValue,
		},
		props: {
			items: {
				default: () => [],
				type: Array,
			},
			value: null,
		},
	};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/header-select.vue